module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1122"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1122"
    },
    "bundlingPackage": "LoginUI",
    "bundlingPackageVersion": "static-1.14821",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};